export const SUMMARY_HEADERS = [
  { id: 1, label: 'In Progress', columnName: 'in-progress-count', sx: { paddingLeft: 2 } },
  { id: 2, label: 'Success', columnName: 'success-count', sx: { paddingLeft: 2 } },
  { id: 3, label: 'Error', columnName: 'error-count', sx: { paddingLeft: 2 } },
];
export const BULK_CREATE_ORGANIZATION_ITEMS_HEADERS = [
  { id: 1, label: 'ID', columnName: 'id', sx: { paddingLeft: 2 } },
  { id: 2, label: 'Email', columnName: 'email', sx: { paddingLeft: 2 } },
  { id: 3, label: 'First Name', columnName: 'first-name', sx: { paddingLeft: 2 } },
  { id: 4, label: 'Last Name', columnName: 'last-name', sx: { paddingLeft: 2 } },
  {
    id: 5,
    label: 'Organization Name',
    columnName: 'organization-name',
    sx: { paddingLeft: 2 },
  },
  { id: 6, label: 'Seats', columnName: 'seats', sx: { paddingLeft: 2 } },
  { id: 7, label: 'Auto License', columnName: 'auto-license', sx: { paddingLeft: 2 } },
  { id: 8, label: 'Plan', columnName: 'plan', sx: { paddingLeft: 2 } },
  { id: 9, label: 'Status', columnName: 'status', sx: { paddingLeft: 2 } },
  {
    id: 10,
    label: 'Status Description',
    columnName: 'status-description',
    sx: { paddingLeft: 2 },
    size: 360,
  },
  {
    id: 11,
    label: 'Last Updated On',
    columnName: 'last-updated-on',
    sx: { paddingLeft: 2 },
    size: 240,
  },
  { id: 12, label: 'Retry Count', columnName: 'retry-count', sx: { paddingLeft: 2 } },
  {
    id: 13,
    label: 'Last Retried On',
    columnName: 'last-retried-on',
    sx: { paddingLeft: 2 },
    size: 240,
  },
];
export const BULK_CREATE_SUBRESELLER_ITEMS_HEADERS = [
  { id: 1, label: 'ID', columnName: 'id', sx: { paddingLeft: 2 } },
  { id: 2, label: 'Email', columnName: 'email', sx: { paddingLeft: 2 } },
  { id: 3, label: 'First Name', columnName: 'first-name', sx: { paddingLeft: 2 } },
  { id: 4, label: 'Last Name', columnName: 'last-name', sx: { paddingLeft: 2 } },
  {
    id: 5,
    label: 'Organization Name',
    columnName: 'organization-name',
    sx: { paddingLeft: 2 },
  },
  { id: 6, label: 'Telephone', columnName: 'telephone', sx: { paddingLeft: 2 } },
  { id: 7, label: 'Billing Address', columnName: 'billing-address', sx: { paddingLeft: 2 } },
  { id: 8, label: 'Postal Code', columnName: 'postal-code', sx: { paddingLeft: 2 } },
  { id: 9, label: 'Archiver Plan', columnName: 'archiver-plan', sx: { paddingLeft: 2 } },
  { id: 10, label: 'Backup Plan', columnName: 'backup-plan', sx: { paddingLeft: 2 } },
  { id: 11, label: 'Personal Plan', columnName: 'personal-plan', sx: { paddingLeft: 2 } },
  { id: 12, label: 'Password', columnName: 'password', sx: { paddingLeft: 2 } },
  { id: 13, label: 'Status', columnName: 'status', sx: { paddingLeft: 2 } },
  {
    id: 14,
    label: 'Status Description',
    columnName: 'status-description',
    sx: { paddingLeft: 2 },
    size: 360,
  },
  {
    id: 15,
    label: 'Last Updated On',
    columnName: 'last-updated-on',
    sx: { paddingLeft: 2 },
    size: 240,
  },
  { id: 16, label: 'Retry Count', columnName: 'retry-count', sx: { paddingLeft: 2 } },
  {
    id: 17,
    label: 'Last Retried On',
    columnName: 'last-retried-on',
    sx: { paddingLeft: 2 },
    size: 240,
  },
];
export const BULK_MAILBOX_DEACTIVATION_ITEMS_HEADERS = [
  { id: 1, label: 'ID', columnName: 'id', sx: { paddingLeft: 2 }, size: 120 },
  {
    id: 2,
    label: 'Organization Owner ID',
    columnName: 'org-owner-id',
    sx: { paddingLeft: 2 },
    size: 180,
  },
  {
    id: 3,
    label: 'Email Account ID',
    columnName: 'email-account-id',
    sx: { paddingLeft: 2 },
    size: 180,
  },
  { id: 4, label: 'Email', columnName: 'email', sx: { paddingLeft: 2 }, size: 360 },
  { id: 5, label: 'Status', columnName: 'status', sx: { paddingLeft: 2 } },
  {
    id: 6,
    label: 'Status Description',
    columnName: 'status-description',
    sx: { paddingLeft: 2 },
    size: 360,
  },
  {
    id: 7,
    label: 'Last Updated On',
    columnName: 'last-updated-on',
    sx: { paddingLeft: 2 },
    size: 240,
  },
  { id: 8, label: 'Retry Count', columnName: 'retry-count', sx: { paddingLeft: 2 } },
  {
    id: 9,
    label: 'Last Retried On',
    columnName: 'last-retried-on',
    sx: { paddingLeft: 2 },
    size: 240,
  },
];
export const BULK_EXCLUDE_MAILBOX_ITEMS_HEADERS = [
  { id: 1, label: 'ID', columnName: 'id', sx: { paddingLeft: 2 }, size: 90 },
  { id: 2, label: 'Email', columnName: 'email', sx: { paddingLeft: 2 }, size: 240 },
  { id: 3, label: 'Status', columnName: 'status', sx: { paddingLeft: 2 }, size: 90 },
  {
    id: 4,
    label: 'Status Description',
    columnName: 'status-description',
    sx: { paddingLeft: 2 },
    size: 360,
  },
];
export const WORKER_JOB_ITEMS_HEADERS = [
  { id: 1, label: 'ID', columnName: 'id', sx: { paddingLeft: 2 }, size: 50 },
  { id: 2, label: 'Payload', columnName: 'payload', sx: { paddingLeft: 2 }, size: 350 },
  { id: 3, label: 'Status', columnName: 'status', sx: { paddingLeft: 2 }, size: 90 },
  {
    id: 4,
    label: 'Status Description',
    columnName: 'status-description',
    sx: { paddingLeft: 2 },
    size: 360,
  },
];
